import s from '#components/hero-button-parade/HeroButtonParade.module.scss';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

type props = {
  tooltipIcon: JSX.Element;
  textTranslationKey: string;
  disclaimer: JSX.Element;
};

const TooltipInfoText = ({
  tooltipIcon,
  textTranslationKey,
  disclaimer,
}: props) => {
  const { t } = useTranslation();

  return (
    <div className={`${s.notification} tw-mt-4`}>
      <div className="tw-inline-block tw-mr-1.5">{tooltipIcon}</div>
      <span
        className="tw-inline-block"
        dangerouslySetInnerHTML={{
          __html: `${t(textTranslationKey)}`,
        }}
      />
      {disclaimer && <span className={s.buttonInfo}>{disclaimer}</span>}
    </div>
  );
};

export default TooltipInfoText;
